import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import DataTable from '../../DataTable';

@inject('metaDataTemplateStore')
@observer
class StationMetaDataTemplate extends Component {
  title = 'Station Meta Data Template';
  @observable items = [];
  @observable template;

  componentWillMount() {
    const { metaDataTemplateStore } = this.props;
    metaDataTemplateStore.fetchItems();
    this.reset(metaDataTemplateStore.items);
  }

  @action reset(items) {
    this.items = items;
  }

  @action handleSelect(template) {
    console.log('select', template);
    // this.template = template;
    alert(`${template.name} selected`);
  }

  render() {
    const columns = [
      { key: 'id', label: 'ID' },
      { key: 'name', label: 'Name' },
      { key: 'caption', label: 'Caption' },
      { key: 'description', label: 'Description' },
    ];
    const { params: { id } } = this.props;
    const { metaDataTemplateStore } = this.props;
    const slug = `/station/${id}/meta-data`;
    return (
      <Modal
        slug={slug}
        title={'Select Meta Data Template'}
      >
        <DataTable
          slug={slug}
          columns={columns}
          data={this.items}
          onSelect={this.handleSelect}
          readOnly
        />
      </Modal>
    );
  }
}

export default StationMetaDataTemplate;



// WEBPACK FOOTER //
// ./src/components/Station/MetaDataTemplate/StationMetaDataTemplate.js